import React, { useEffect, useState } from 'react';
import { useOuterClick, currencyFormat, deepFind, isDark } from '../../../../helper/Helper'
import { EditionService } from '../../../../services/EditionService';
import { InputGroup, FloatingLabel, Badge, FormControl, Table, Checkbox, Container, Button, Dropdown, DropdownButton, Form, Col, Row, Popover, OverlayTrigger, Tooltip, Alert } from 'react-bootstrap';
import { GlobalContext } from "../../../../services/GlobalProvider";
import { formatTableHeadersFromPrefs, getMonthArrayFromDecimal, getFile } from '../../../../helper/Helper'
import MdReader from '../../../../components/md-reader/MdReader';
import './TypeRender.scss';

const TypeRender = ({ header, tableBodyElement, setError }) => {

    const { globalContextLoaded, preferences, parametres, folderDetails, grants, getPreferences } = React.useContext(GlobalContext);

    function getValueListFromPathWithArray(tableBodyElement, dataTarget) {

        let valuesArray = []

        let pathList = dataTarget.split(".")

        for (let index = 0; index < pathList.length; index++) {
            let currentPath = pathList.slice(0, index + 1).join(".")
            let elemFound = deepFind(tableBodyElement, currentPath)
            if (Array.isArray(elemFound)) {
                elemFound.map(e => {
                    let lastElemString = pathList[pathList.length - 1]
                    valuesArray.push(e[lastElemString])
                })
            }
        }

        return valuesArray

    }


    switch (header.type) {
        case 'img':
            return <span className="picture rounded" style={{ backgroundImage: `url(${tableBodyElement[header.dataTarget]})` }}></span>;
        case 'contributions':
            return (tableBodyElement[header.dataTarget].map(contribution => (
                <small key={contribution._id} className="bg-gray-100 m-1 px-1 rounded d-inline-block">{contribution.libelle} </small>
            )))
        case 'codesbarres':
            return (tableBodyElement[header.dataTarget].map(codeBarre => (
                <small key={codeBarre} className="bg-gray-100 m-1 px-1 rounded d-inline-block">{codeBarre} </small>
            )))
        case 'tags':
            return <span className="type-render-bubble-container">
                {
                    deepFind(tableBodyElement, header.dataTarget).map(tag => (
                        <span key={tag._id} className="type-render-bubble-tag" style={{ backgroundColor: tag.couleur }}>
                            <span style={{ backgroundColor: tag.couleur }} className={"label " + (isDark(tag.couleur) ? "text-dark" : "text-white")}>{tag.tag}</span>
                        </span>
                    ))
                }
            </span>
        case 'tarifs': /* N'est plus utilisé ? */
            return (tableBodyElement[header.dataTarget].map(tarif => (
                <small key={tarif} className="bg-gray-100 m-1 px-1 rounded d-inline-block">{tarif.tarif_id}</small>
            )))
        case 'date':
            return <>
                {/* {deepFind(tableBodyElement, header.dataTarget) ? new Date(deepFind(tableBodyElement, header.dataTarget)).toLocaleString() : ""} */}
                <div className="d-flex align-items-center">
                    {deepFind(tableBodyElement, header.dataTarget) ? new Date(deepFind(tableBodyElement, header.dataTarget)).toLocaleDateString() : ""}
                    <OverlayTrigger placement="top" overlay={
                        <Tooltip>
                            {String(new Date(deepFind(tableBodyElement, header.dataTarget)).getHours()).padStart(2, '0')}h
                            {String(new Date(deepFind(tableBodyElement, header.dataTarget)).getMinutes()).padStart(2, '0')}
                        </Tooltip>
                    }>
                        <i className="material-icons d-inline-flex ms-1 text-gray-800">access_time</i>
                    </OverlayTrigger>
                </div>
            </>;
        case 'etatProforma':
            if (deepFind(tableBodyElement, header.dataTarget) == "expiree") {
                return <Badge bg="warning" className="text-dark">Expirée</Badge>
            }
            if (deepFind(tableBodyElement, header.dataTarget) == "annulee") {
                return <Badge bg="danger">Annulée</Badge>
            }
            if (deepFind(tableBodyElement, header.dataTarget) == "facturee") {
                return <Badge bg="primary-500">Facturée</Badge>
            }
            if (deepFind(tableBodyElement, header.dataTarget) == "encours") {
                return <Badge bg="success">En cours</Badge>
            }
            return null
        case 'string':
            return <span className="text-break">{deepFind(tableBodyElement, header.dataTarget)}</span>;
        case 'number':
            return <>{deepFind(tableBodyElement, header.dataTarget)}</>;
        case 'gps':

            if (deepFind(tableBodyElement, header.dataTarget)[0] || deepFind(tableBodyElement, header.dataTarget)[1]) {
                return <>

                    <OverlayTrigger trigger={["hover", "focus"]} placement="top" overlay={
                        <Popover>
                            <Popover.Body>
                                <span className="me-2 d-block"><b>Latitude : </b>{deepFind(tableBodyElement, header.dataTarget)[0]}</span>
                                <span className="me-2 d-block"><b>Longitude : </b>{deepFind(tableBodyElement, header.dataTarget)[1]}</span>
                            </Popover.Body>
                        </Popover>
                    }>

                        <i className="material-icons d-inline-flex text-gray-600 bg-gray-200 px-1 me-1 type-render-bubble">location_on</i>
                    </OverlayTrigger>


                </>

            } else {
                return null
            }


        case 'percentage':
            return <>{deepFind(tableBodyElement, header.dataTarget) > 0 && deepFind(tableBodyElement, header.dataTarget) + '%'}</>;
        case 'genericList':
            let valuesArray = getValueListFromPathWithArray(tableBodyElement, header.dataTarget)
            return (valuesArray.map((val, i) => (
                <small key={i} className="bg-gray-100 m-1 px-1 rounded d-inline-block">{val}</small>
            )))
        case 'dateList':
            let valuesArrDate = getValueListFromPathWithArray(tableBodyElement, header.dataTarget)
            return (valuesArrDate.map((val, i) => (
                <small key={i} className="bg-gray-100 m-1 px-1 rounded d-inline-block">{val ? new Date(val).toLocaleString() : ""}</small>
            )))
        case 'currency':
            return <>{currencyFormat(deepFind(tableBodyElement, header.dataTarget))}</>;
        case 'scheduled':
            return <OverlayTrigger trigger={["hover", "focus"]} placement="top" overlay={
                <Popover className="type-render-scheduled">
                    <Popover.Header as="h3">Planification</Popover.Header>
                    <Popover.Body>
                        <span className="d-inline-flex w-100 fw-bold small mb-2">
                            {getMonthArrayFromDecimal(deepFind(tableBodyElement, header.dataTarget))?.map(month => (
                                <span className={"d-flex flex-column align-items-center border border-white py-1 " + (month.value == true ? "bg-primary-600 text-white " : "bg-gray-200 text-gray-600 ")} key={month.libelle} style={{ width: (100 / 12 + '%') }}>
                                    <small className="fw-normal">{month.libelle}</small>
                                </span>
                            ))}
                        </span>
                    </Popover.Body>
                </Popover>
            }>
                <span className="d-inline-flex">
                    {getMonthArrayFromDecimal(deepFind(tableBodyElement, header.dataTarget))?.map(month => (
                        <span className={"type-render-scheduled-month d-flex"} key={month.libelle}>
                            <span className={"square " + (month.value == true ? "bg-primary-600 " : "bg-gray-300 ")}></span>
                        </span>
                    ))}
                </span>
            </OverlayTrigger>
        case 'currencyHighlightNegative':
            return <span className={"px-1 " + (deepFind(tableBodyElement, header.dataTarget) < 0 ? "bg-danger text-white rounded" : "")}>{currencyFormat(deepFind(tableBodyElement, header.dataTarget))}</span>;
        case 'bloquer':
            if (deepFind(tableBodyElement, header.dataTarget) == true) {
                return <Badge bg="danger" text='white' className="align-items-center d-inline-flex"><i className="material-icons me-1">warning</i>Bloqué</Badge>
            }
            return null
        case 'boolean':
            if (deepFind(tableBodyElement, header.dataTarget) == true) {
                return <span className="py-1 px-2 text-success d-flex"><i className="material-icons me-1">check</i>Oui</span>;
            }
            if (deepFind(tableBodyElement, header.dataTarget) == false) {
                return <span className="py-1 px-2 text-danger d-flex"><i className="material-icons me-1">close</i>Non</span>;
            }
            return null
        case 'booleanTrueOnly':
            if (deepFind(tableBodyElement, header.dataTarget) == true) {
                return <span className="py-1 px-2 text-success d-flex"><i className="material-icons me-1">check</i>Oui</span>;
            }
            return null
        case 'booleanFalseOnly':
            if (deepFind(tableBodyElement, header.dataTarget) == false) {
                return <span className="py-1 px-2 text-danger d-flex"><i className="material-icons me-1">close</i>Non</span>;
            }
            return null
        case 'reglements':
            function getReglementsPDF(reglement) {
                setError()
                EditionService.getReglement(folderDetails?.dossier?._id, reglement._id, "pdf").then(res => {
                    if (!res.data) {
                        setError({ statusText: res.statusText })
                    } else {
                        getFile(res)
                    }
                }).catch(error => {
                    setError(error)
                });
            }
            return (
                <div className="reglement-list-container">
                    {tableBodyElement[header.dataTarget].map(reglement => (
                        <span key={reglement._id} className="reglement-container">
                            <small className="px-1 bg-gray-200 text-gray-700 border rounded me-1 mb-1">{reglement?.mode_paiement_libelle}</small>
                            <span onClick={e => e.stopPropagation()} className="reglement-tooltip bg-white p-3 border rounded">
                                <h6 className=""><b>{reglement.client_nom}</b></h6>
                                <p className="m-0 p-0"><b>Date : </b>{new Date(reglement.date).toLocaleString()}</p>
                                <p className="m-0 p-0"><b>Montant : </b>{reglement.montant}</p>
                                <p className="m-0 p-0"><b>Mode de paiement : </b>{reglement.mode_paiement_libelle}</p>
                                <Button onClick={() => getReglementsPDF(reglement)} variant="link" className="p-0">Imprimer le règlement</Button>
                            </span>
                        </span>
                    ))}
                </div>
            );
        case 'fournisseurs':
            return (tableBodyElement[header.dataTarget].map((fournisseur, i) => (
                <span key={i}>
                    {fournisseur.fournisseur_id &&
                        <OverlayTrigger trigger={["hover", "focus"]} placement="top" overlay={
                            <Popover>
                                <Popover.Header as="h3">{fournisseur.fournisseur[0]?.nom}</Popover.Header>
                                <Popover.Body>
                                    {fournisseur.date_achat && <span className="me-2 d-block"><b>Date d'achat : </b>{new Date(fournisseur.date_achat).toLocaleString()}</span>}
                                    {fournisseur.prix_achat && <span className="me-2 d-block"><b>Prix d'achat : </b>{fournisseur.prix_achat}</span>}
                                    {fournisseur.devise && <span className="me-2 d-block"><b>Devise : </b>{fournisseur.devise}</span>}
                                </Popover.Body>
                            </Popover>
                        }>
                            <i className="material-icons d-inline-flex text-gray-600 bg-gray-200 px-1 me-1 type-render-bubble">local_shipping</i>
                        </OverlayTrigger>
                    }
                </span>
            )));
        case 'markdown':
            return (
                <>
                    {tableBodyElement[header.dataTarget] &&
                        <OverlayTrigger trigger={["hover", "focus"]} placement="top" overlay={
                            <Popover>
                                <Popover.Body>
                                    <MdReader mdData={tableBodyElement[header.dataTarget]} />
                                </Popover.Body>
                            </Popover>
                        }>
                            <i className="material-icons d-inline-flex text-gray-600 bg-gray-200 px-1 me-1 type-render-bubble">wysiwyg</i>
                        </OverlayTrigger>
                    }
                </>
            );
        case 'facture':
            return (
                <OverlayTrigger trigger={["hover", "focus"]} placement="top" overlay={
                    <Popover>
                        <Popover.Body>
                            {tableBodyElement[header.dataTarget].client_nom && <span className="me-2 d-block"><b>Client : </b>{tableBodyElement[header.dataTarget].client_nom}</span>}
                            {tableBodyElement[header.dataTarget].code && <span className="me-2 d-block"><b>Code facture : </b>{tableBodyElement[header.dataTarget].code}</span>}
                        </Popover.Body>
                    </Popover>
                }>
                    <i className="material-icons d-inline-flex text-gray-600 bg-gray-200 px-1 me-1 type-render-bubble">receipt_long</i>
                </OverlayTrigger>
            );
        case 'article':
            return (
                <>
                    {tableBodyElement[header.dataTarget] &&
                        <OverlayTrigger trigger={["hover", "focus"]} placement="top" overlay={
                            <Popover>
                                <Popover.Body>
                                    {tableBodyElement[header.dataTarget]?.code && <span className="me-2 d-block"><b>Code : </b>{tableBodyElement[header.dataTarget].code}</span>}
                                    {tableBodyElement[header.dataTarget]?.designation && <span className="me-2 d-block"><b>Désignation : </b>{tableBodyElement[header.dataTarget].designation}</span>}
                                </Popover.Body>
                            </Popover>
                        }>
                            <i className="material-icons d-inline-flex text-gray-600 bg-gray-200 px-1 me-1 type-render-bubble">inventory</i>
                        </OverlayTrigger>
                    }
                </>
            );
        case 'adresses':
            return (deepFind(tableBodyElement, header.dataTarget).map(adresse => (
                <OverlayTrigger key={adresse._id} trigger={["hover", "focus"]} placement="top" overlay={
                    <Popover>
                        {adresse.libelle && <Popover.Header as="h3">{adresse.libelle}</Popover.Header>}
                        <Popover.Body>
                            {adresse.adresse && <span className="me-2 d-block"><b>Adresse : </b>{adresse.adresse}</span>}
                            {adresse.libelle && <span className="me-2 d-block"><b>Libelle : </b>{adresse.libelle}</span>}
                            {adresse.code_postal && <span className="me-2 d-block"><b>CP : </b>{adresse.code_postal}</span>}
                            {adresse.ville && <span className="me-2 d-block"><b>Ville : </b>{adresse.ville}</span>}
                            {adresse.pays && <span className="me-2 d-block"><b>Pays : </b>{adresse.pays}</span>}
                            {adresse.principal && <span className="me-2 d-block"><b>Adresse principale : </b>{adresse.principal ? 'oui' : 'non'}</span>}
                            {adresse.observation && <span className="me-2 d-block"><b>Observation : </b>{adresse.observation}</span>}
                        </Popover.Body>
                    </Popover>
                }>
                    <i className="material-icons d-inline-flex text-gray-600 bg-gray-200 px-1 me-1 type-render-bubble">home</i>

                </OverlayTrigger>
            )));
        case 'interlocuteurs':
            return (deepFind(tableBodyElement, header.dataTarget)?.map(interlocuteur => (
                <OverlayTrigger key={interlocuteur._id} trigger={["hover", "focus"]} placement="top" overlay={
                    <Popover>
                        <Popover.Header as="h3">{interlocuteur?.nom} {interlocuteur?.prenom}</Popover.Header>
                        <Popover.Body>

                            {interlocuteur.service && <span className="me-2 d-block"><b>Service : </b>{interlocuteur.service}</span>}
                            <span className="me-2 d-block"><b>Interlocuteur principal : </b>{interlocuteur.principal ? 'oui' : 'non'}</span>
                            {interlocuteur?.mails?.length > 0 &&
                                <div>
                                    <b>Mails :</b>
                                    {interlocuteur?.mails.map(mail => (
                                        <span key={mail} className="d-flex px-1 bg-gray-100 w-100 rounded mb-1">{mail}</span>
                                    ))}
                                </div>
                            }
                            {interlocuteur.observation && <span className="me-2 d-block"><b>Observation : </b>{interlocuteur.observation}</span>}
                        </Popover.Body>
                    </Popover>
                }>
                    <i className="material-icons d-inline-flex text-gray-600 bg-gray-200 px-1 me-1 type-render-bubble">person</i>
                </OverlayTrigger>
            )));
        case 'interlocuteur':
            return (
                <>
                    {tableBodyElement[header.dataTarget] &&
                        <OverlayTrigger trigger={["hover", "focus"]} placement="top" overlay={
                            <Popover>
                                <Popover.Body>
                                    {tableBodyElement[header.dataTarget]?.nom && <span className="me-2 d-block"><b>Nom : </b>{tableBodyElement[header.dataTarget].nom}</span>}
                                    {tableBodyElement[header.dataTarget]?.prenom && <span className="me-2 d-block"><b>Prenom : </b>{tableBodyElement[header.dataTarget].prenom}</span>}
                                    {tableBodyElement[header.dataTarget]?.service && <span className="me-2 d-block"><b>Service : </b>{tableBodyElement[header.dataTarget].service}</span>}
                                    {tableBodyElement[header.dataTarget]?.observation && <span className="me-2 d-block"><b>Observation : </b>{tableBodyElement[header.dataTarget].observation}</span>}
                                    {tableBodyElement[header.dataTarget]?.tel?.length > 0 &&
                                        <div className="w-100">
                                            <b>Téléphone(s) : </b>
                                            {tableBodyElement[header.dataTarget]?.tel.map(tel => (
                                                <span key={tel} className="rounded bg-gray-100 px-1 me-1 mb-1">{tel}</span>
                                            ))}
                                        </div>
                                    }
                                    {tableBodyElement[header.dataTarget]?.mails?.length > 0 &&
                                        <div className="w-100">
                                            <b>Email(s) : </b>
                                            {tableBodyElement[header.dataTarget]?.mails.map(mails => (
                                                <span key={mails} className="rounded bg-gray-100 px-1 me-1 mb-1">{mails}</span>
                                            ))}
                                        </div>
                                    }
                                    {tableBodyElement[header.dataTarget]?.isMailInvalid &&
                                        <Alert variant="warning" className="px-3 py-2 mt-2">
                                            Adresse email non valide.
                                        </Alert>
                                    }
                                </Popover.Body>
                            </Popover>
                        }>
                            {tableBodyElement[header.dataTarget]?.isMailInvalid ?
                                <span className="d-inline-flex px-1 bg-warning rounded">
                                    <i className="material-icons me-1">warning</i>
                                    <span>Email non valide.</span>
                                </span>
                                :
                                <span>
                                    {tableBodyElement[header.dataTarget]?.mails?.length > 0 &&
                                        <>
                                            {tableBodyElement[header.dataTarget]?.mails.map((mail, i) => (
                                                <span key={mail} className="d-inline-flex bg-gray-200 rounded px-1 me-1 mb-1">
                                                    {mail}
                                                </span>
                                            ))}
                                        </>
                                    }
                                </span>
                            }
                        </OverlayTrigger>
                    }
                </>
            );
        case 'historiques':
            if(
                (tableBodyElement[header.dataTarget]?.precedents?.filter(document => (document._id !== tableBodyElement._id)).length <= 0) 
                && (tableBodyElement[header.dataTarget]?.suivants?.filter(document => (document._id !== tableBodyElement._id)).length <= 0) 
            ){
                return
            }
            return (
                <span>
                    <span className="d-flex align-items-center" style={{ fontSize: "0.75em" }}>
                        {tableBodyElement[header.dataTarget]?.precedents?.filter(document => (document._id !== tableBodyElement._id))?.map((document, i) => (
                            <span className="d-flex align-items-center" key={i}>
                                <span className="px-2 py-1 bg-gray-300 text-gray-700 rounded fw-bold">
                                    {document.type == "avoir" && <>Av</>}
                                    {document.type == "abonnement" && <>Ab</>}
                                    {document.type == "proforma" && <>P</>}
                                    {document.type == "facture" && <>F</>}
                                </span>
                                <i className="material-icons d-inline-block text-gray-500 m-n1 bg-white border rounded zindex-10">arrow_right</i>
                            </span>
                        ))}
                        {((tableBodyElement[header.dataTarget]?.precedents?.length > 0) || (tableBodyElement[header.dataTarget]?.suivants?.length > 0)) &&
                            <span className="px-2 py-1 bg-primary-200 text-primary-600 rounded fw-bold border border-2 border-primary-300">
                                <i className="material-icons d-inline-block i-lg">insert_drive_file</i>
                            </span>
                        }
                        {tableBodyElement[header.dataTarget]?.suivants?.filter(document => (document._id !== tableBodyElement._id))?.map((suivant, i) => (
                            <span className="d-flex align-items-center" key={i}>
                                <i className="material-icons d-inline-block text-gray-500 m-n1 bg-white border rounded zindex-10">arrow_right</i>
                                <span className="px-2 py-1 bg-gray-300 text-gray-700 rounded fw-bold">
                                    {suivant.type == "avoir" && <>Av</>}
                                    {suivant.type == "abonnement" && <>Ab</>}
                                    {suivant.type == "proforma" && <>P</>}
                                    {suivant.type == "facture" && <>F</>}
                                </span>
                            </span>
                        ))}
                    </span>
                </span>
            );
        default:
            return <>[Erreur : Type Inconnu]</>;
    }
}

export default TypeRender;